import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  insightPostId: string;
};

type MessageWithIdType = ResponseMessageType & {
  id: string;
};

const request = ({ insightPostId }: RequestDataType) => {
  return new ApiClient()
    .post<MessageWithIdType>(
      `/api/members/insight_posts/${insightPostId}/likes`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisInsightPostsLikesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<MessageWithIdType, RequestDataType> => {
  return useMutation(request, { ...options });
};
